import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapperProps: BoxProps = {
  bg: 'alpha.500',
  h: '100%',
  minW: '460px',
  display: 'flex',
  justifyContent: 'center',
  borderRightRadius: ['unset', null, 'lg'],
  sx: {
    'div:first-child': {
      display: 'flex',
      flexDir: 'column',
      fontSize: 'xs',
      fontWeight: 'medium',
      alignItems: 'flex-start',
      svg: {
        boxSize: '2.5',
        mr: '1',
        mt: '-1px',
      },
      '.chakra-link': {
        mb: '4',
        color: 'beta.500',
      },
      p: {
        color: 'white',
        fontFamily: 'accent',
        fontWeight: 'normal',
      },
    },
  },
};

export const TextForgotPasswordSuccess: CSSObject = {
  color: 'white',
  fontSize: 'sm',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'medium',
  mb: '2',

  '+ a': {
    display: 'none',
  },
};

export const linkLoginProps: CSSObject = {
  color: 'alpha.400',
};

export const ForgotPasswordButton: CSSObject = {
  fontWeight: 'normal',
};
